import { Trans, useTranslation } from 'next-i18next';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Modal } from '@components/common';
import { useEffect, useState } from 'react';
import { HandThumbUpIcon } from '@heroicons/react/24/solid';

// Interface
// ******************************************
interface RedirectCountdownModalProps {
  url: string;
  seconds: number;
}

/**
 * @description Redirect modal data component
 *
 * - **locale** -Locale - The current app locale.
 */
export const RedirectCountdownModal = NiceModal.create((props: RedirectCountdownModalProps) => {
  // Destructure props
  const {
    url, seconds,
  } = props;

  // Translation
  const { t } = useTranslation('common');

  // Use a hook to manage the modal state
  const modal = useModal();
  const [countdown, setCountdown] = useState(seconds);


  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          document.location.href = url;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [url]);

  // Render component
  // *****************************************************
  return (
    <Modal
      isOpen={modal.visible}
      size="sm"
      onClose={
        /* Pass an empty function because we don't want to close the modal on backdrop click or on ESC key. */
        () => {}
      }
      className="!overflow-visible !rounded-md border-l-8 border-secondary"
    >
      <Modal.Body className="bg-surface-50">

        <div className="flex items-start gap-5">
          <HandThumbUpIcon className="size-7 text-secondary" />
          <div>
            <h2 className="text-2xl font-bold">{t('global.label.congrats')}</h2>

            <h3 className="text-xl font-bold">
              <Trans
                i18nKey="global.label.job.activated"
                components={{ span: <span className="text-secondary" /> }}
              />
            </h3>
            <p className="mb-5 text-md text-ink-medium">
              {t('global.label.redirect.to.payment')}
            </p>

            <Button size="xs" styling="solid" color="secondary">
              {t('global.label.go.to.payment')}
              (
              {countdown}
              )
            </Button>

          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
});
